<template>
  <div class="shell-page">
    <HeaderMain />

    <section class="legal-shell">
      <div class="glass-surface legal-card">
        <div class="section-heading">
          <span class="section-heading__eyebrow">Compania y operacion</span>
          <h1 class="section-heading__title">Compania</h1>
          <p class="section-heading__text">
            Esta pagina resume quien opera FOMOPLANES, cual es su alcance como plataforma y como se relaciona con compradores, organizadores y procesadores de pago.
          </p>
        </div>

        <div class="legal-card__content">
          <section class="legal-page__highlight">
            <span class="legal-page__pill">Identidad legal</span>
            <h2 class="legal-page__highlight-title">FOMOPLANES es parte de GINGO ENTERPRISES LLC</h2>
            <p>
              Direccion comercial registrada: 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110.
            </p>
            <p>
              Correo oficial publicado para soporte y consultas: <a class="legal-page__text-link" href="mailto:fomoplanes@sudenec.com">fomoplanes@sudenec.com</a>.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>1. Que hace FOMOPLANES</h2>
            <p>
              FOMOPLANES funciona como plataforma digital para descubrir experiencias, promocionar eventos y facilitar la venta, emision y validacion de accesos de terceros y de experiencias identificadas expresamente como propias o coorganizadas.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>2. Relacion con organizadores</h2>
            <p>
              Los organizadores son responsables por la informacion comercial del evento, su ejecucion, condiciones operativas, cambios de programacion y autorizaciones de reembolso cuando corresponda. FOMOPLANES puede actuar como canal de distribucion, promocion, soporte y coordinacion operativa.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>3. Pagos y cumplimiento</h2>
            <p>
              La plataforma puede trabajar con Stripe y otros procesadores autorizados para cobrar entradas, addons y servicios relacionados. Cada operacion puede estar sujeta a controles antifraude, autenticaciones reforzadas, revisiones documentales y reglas regulatorias del metodo de pago utilizado.
            </p>
          </section>

          <section class="legal-page__section">
            <h2>4. Canales publicos</h2>
            <p>
              La informacion publica de compania, contacto, privacidad, reembolsos y terminos forma parte del marco de transparencia del servicio y complementa la experiencia de compra disponible en el sitio.
            </p>
          </section>

          <div class="legal-page__actions">
            <router-link :to="{ name: 'terms' }">Terminos y condiciones</router-link>
            <router-link :to="{ name: 'privacy' }">Politica de privacidad</router-link>
            <router-link :to="{ name: 'refunds' }">Reembolsos y cancelaciones</router-link>
            <router-link :to="{ name: 'contact' }">Contacto</router-link>
          </div>
        </div>
      </div>
    </section>

    <FooterMain />
  </div>
</template>

<script>
import HeaderMain from '@/components/HeaderMain.vue'
import FooterMain from '@/components/FooterMain.vue'

export default {
  name: 'CompanyView',

  components: {
    HeaderMain,
    FooterMain,
  },
}
</script>

<style>
</style>
